'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC } from 'react';
import Button from '~/components/button';
import { useCallModal } from '~/layouts/app-layout/components/header/call-modal-provider';
import nbspPreposition from '~/utils/nbsp-preposition';
import sanitizeHtml from '~/utils/sanitize-html';

import styles from './styles.module.css';
import { PriceRow } from './utils';

const formatPrice = (price: string | null): string | null => (price ? `от ${price} руб/м2` : null);

interface Props {
  rows: PriceRow[];
}

const PriceTable: FC<Props> = ({ rows }) => {
  const { openModal, isAvailable: withButtons } = useCallModal();
  const pathname = usePathname().replace(/\/$/, '');

  return (
    <table className={clsx(styles.table, withButtons && styles.withButtons)}>
      <thead>
        <tr>
          <th>Услуга</th>
          <th colSpan={withButtons ? 2 : undefined}>Ориентировочная стоимость</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td className={styles.title}>
              {row.href === pathname ? (
                <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(nbspPreposition(row.title)) }} />
              ) : (
                <Link
                  href={row.href}
                  className={styles.link}
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(nbspPreposition(row.title)) }}
                />
              )}
            </td>
            <td className={styles.price}>{formatPrice(row.price)}</td>
            {withButtons && (
              <td className={styles.action}>
                <Button
                  className={styles.button}
                  title="Оставить заявку"
                  onClick={() => openModal({ serviceName: row.title })}
                />
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PriceTable;
